import './jquery-global.js';
import './svg-sprite.js';

import 'fullpage.js/dist/jquery.fullpage.js';
import 'remodal';

import $ from 'jquery';
import overlayScrollbars from 'overlayscrollbars/js/OverlayScrollbars';

import init from './helpers/init';
import FullPage from './widgets/FullPage';
import Tabs from './widgets/Tabs';
import ShowIcon from './widgets/ShowIcon';
import Preloader from './widgets/Preloader';
import Sound from './widgets/Sound';
import initPopups from './includes/popups';
import { bindPageLinks, mountPage } from './includes/page';

const $document = $(document);

$(() => {
  init('.js-preloader', Preloader);
  init('.js-tabs', Tabs);
  init('.js-show-icon', ShowIcon);
  mountPage();
  bindPageLinks();

  $document.on('opened', '.remodal', () => FullPage.lock(true));
  $document.on('closed', '.remodal', () => FullPage.lock(false));

  overlayScrollbars(document.querySelectorAll('.js-scroll'), {
    className: '_custom'
  });

  initPopups();
});

$(window).on('load', () => {
  init('.js-sound', Sound);
});
